var _a;
export default JSON.parse((_a = process.env.REACT_APP_LOCALES) !== null && _a !== void 0 ? _a : '[]');
//# sourceMappingURL=locales.js.map